import { useMemo, useState, type ReactNode } from "react";
import { I18nContext } from "./context";
import type { Locale } from "./translations";

export function I18nProvider({
  children,
  defaultLocale = "en",
}: {
  children: ReactNode;
  defaultLocale?: Locale;
}) {
  const [locale, setLocale] = useState<Locale>(defaultLocale);
  const value = useMemo(() => ({ locale, setLocale }), [locale]);
  return <I18nContext value={value}>{children}</I18nContext>;
}
